const CREATE_POST_TEXT = "CREATE_POST_TEXT";
const CREATE_POST_EMOJI = "CREATE_POST_EMOJI";
const CREATE_POST_MEDIA = "CREATE_POST_MEDIA";
const CREATE_POST_CLEAR = "CREATE_POST_CLEAR";
const COMMENT_TEXT = "COMMENT_TEXT";
const COMMENT_EMOJI = "COMMENT_EMOJI";
const COMMENT_MEDIA = "COMMENT_MEDIA";
const COMMENT_CLEAR = "COMMENT_CLEAR";

export {
    CREATE_POST_TEXT,
    CREATE_POST_EMOJI,
    CREATE_POST_MEDIA,
    CREATE_POST_CLEAR,
    COMMENT_TEXT,
    COMMENT_EMOJI,
    COMMENT_MEDIA,
    COMMENT_CLEAR
};